import config from '@/config';

export const createMarketingSitePath = (relativePath: string) =>
  `${config.seo.baseUrl}${relativePath}`;
